import { getLocalizedPath } from '../i18n/localizedRoutes';
import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { ziruiProfile } from '../pages/ziruiProfileData';

const Footer = () => {
  const { t, locale } = useI18n();
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} YCH-YOYO</p>
      <Link to={getLocalizedPath('/shipping', locale)}>{t('footer.shipping')}</Link>
      <Link to={getLocalizedPath('/contact', locale)}>{t('footer.contact')}</Link>
      <Link to={getLocalizedPath(ziruiProfile.path, locale)}>{t('profile.name')}</Link>
      <a href={ziruiProfile.website} target="_blank" rel="noopener noreferrer">{t('profile.footer')}</a>
      
      {/* <p><a href="mailto:ychenghao783@gmail.com">info@loopinfinity.com</a></p> */}
      {/* Add Social Media Icons/Links here */}
    </footer>
  );
};

export default Footer;
